import {
  MenuCategoryStatusSchema,
  type MenuCategoryStatus as GeneratedMenuCategoryStatus
} from '~/services/api/generated'

export type MenuCategoryStatus = GeneratedMenuCategoryStatus

export const MenuCategoryStatus = {
  ACTIVE: MenuCategoryStatusSchema.enum.active,
  INACTIVE: MenuCategoryStatusSchema.enum.inactive
}

export const MenuCategoryStatusValues = [
  MenuCategoryStatusSchema.enum.active,
  MenuCategoryStatusSchema.enum.inactive
]
